module.exports = __webpack_public_path__ + "static/media/screen.ffd94f10.jpg";